"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultValues = {
  spacing: {
    base: 8
  },
  fontSize: {
    base: 14
  },
  fonts: {
    "default": 'Open Sans, Arial, sans-serif',
    heading: 'Open Sans, Arial, sans-serif',
    text: 'Open Sans, Arial, sans-serif',
    futura: 'Futura Medium, Arial, sans-sarif'
  },
  colors: {
    "default": '#727588',
    primary: '#7D1DD1',
    secondary: '#C50A27',
    text: '#FFFFFF',
    lightText: '#FFFFFF',
    uiText: '#FFFFFF',
    placeholder: '#8E8E8E',
    background: '#F1F3F7',
    foreground: '#7D1DD1',
    success: '#07DCAC',
    error: '#FF4F65',
    info: '#2F86EB',
    warn: '#FFC021',
    disabled: '#737689',
    loginInput: '#7D1DD1',
    signupButton: '#FFFFFF',
    sideMenuButton: '#FFFFFF',
    sideMenuText: '#000000',
    button: '#7D1DD1',
    buttonText: '#FFFFFF'
  }
};

var DesignSystem = function DesignSystem() {
  var _this = this;

  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, DesignSystem);

  _defineProperty(this, "updateValues", function () {
    var newValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mergedValues = (0, _lodash["default"])(defaultValues, newValues);
    Object.assign(_this, mergedValues);
  });

  _defineProperty(this, "getSpacing", function () {
    var times = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var spacing = _this.spacing.base * times;
    return unit ? "".concat(spacing).concat(unit) : spacing;
  });

  _defineProperty(this, "getFontSize", function () {
    var times = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var fontSize = _this.fontSize.base * times;
    return unit ? "".concat(fontSize).concat(unit) : fontSize;
  });

  _defineProperty(this, "getColor", function (key) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var color = _this.colors[key];

    if (color) {
      return color;
    }

    if (opts.fallback) {
      return _this.colors[opts.fallback];
    }

    if (opts.useDefault) {
      return _this.colors["default"];
    }

    return undefined;
  });

  _defineProperty(this, "getFont", function (key) {
    return _this.fonts[key] || _this.fonts["default"];
  });

  var _mergedValues = (0, _lodash["default"])(defaultValues, values);

  Object.assign(this, _mergedValues);
};

var _default = DesignSystem;
exports["default"] = _default;

//# sourceMappingURL=DesignSystem.js.map